// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="M13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-2h-2v-3h1a2 2 0 1 0-2-2H8a4 4 0 1 1 5 3.87V15ZM12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 18a10 10 0 1 1 0-20 10 10 0 0 1 0 20Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
